import { render, staticRenderFns } from "./ExerciseStatisticsExplorer.vue?vue&type=template&id=2b155f10&scoped=true"
import script from "./ExerciseStatisticsExplorer.vue?vue&type=script&lang=js"
export * from "./ExerciseStatisticsExplorer.vue?vue&type=script&lang=js"
import style0 from "./ExerciseStatisticsExplorer.vue?vue&type=style&index=0&id=2b155f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b155f10",
  null
  
)

export default component.exports